import PreviewDetailImg from 'assets/images/feature-slots/preview_detail.png';
import PreviewDListlImg from 'assets/images/feature-slots/preview_list.png';
import { SLOT_KEY, getRouteName } from './common';

const MODULE_NAME = 'Quote';

const routes = [
    {
        matchRegex: '/Quote/Create',
        name: getRouteName(MODULE_NAME, 'Log Quote'),
        slots: [
            SLOT_KEY.SLOT_SECTION,
            SLOT_KEY.SLOT_V_SECTION,
            SLOT_KEY.SLOT_SCRIPTS
        ],
        image: PreviewDListlImg,
        parentKeys: {
            [SLOT_KEY.SLOT_SECTION]: [
                { key: 'page-title-main', label: 'Section Page Title' },
            ],
            [SLOT_KEY.SLOT_V_SECTION]: [
                { key: 'wrapper-form', label: 'Wrapper Form' },
                { key: 'wrapper-action-form', label: 'Wrapper Action Form' },
            ],
        },
        options: {
            [SLOT_KEY.SLOT_SCRIPTS]: [
                {
                    key: 'MARKETPLACE_EVENT_BEFORE_SUBMIT_FORM',
                    label: 'Triggered Before Submit Form',
                },
            ],
        },
    },
    {
        matchRegex: '/Quote',
        name: getRouteName(MODULE_NAME, 'All Quote'),
        slots: [
            SLOT_KEY.SLOT_ADDITION_MENU,
            SLOT_KEY.SLOT_SCRIPTS,
            SLOT_KEY.SLOT_V_TABLE_COLUMN
        ],
        image: PreviewDListlImg,
        options: {
            [SLOT_KEY.SLOT_SCRIPTS]: [
                { key: 'MARKETPLACE_EVENT_TAB_CHANGE', label: 'Before Tab Change' },
                { key: 'MARKETPLACE_EVENT_TOGGLE_VIEW', label: 'Before Toogle View' },
                {
                    key: 'MARKETPLACE_EVENT_TOGGLE_BATCHING',
                    label: 'Before Toogle Batching',
                },
                {
                    key: 'MARKETPLACE_EVENT_TOGGLE_TABLE_SETTING',
                    label: 'Before Toogle Table Setting',
                },
            ],
        }
    },
    {
        matchRegex: '/Quote/Detail/:id',
        name: getRouteName(MODULE_NAME, 'Detail'),
        slots: [
            SLOT_KEY.SLOT_ADDITION_MENU,
            SLOT_KEY.SLOT_TAB,
            SLOT_KEY.SLOT_CONTENT,
            SLOT_KEY.SLOT_SCRIPTS,
            SLOT_KEY.SLOT_SECTION,
            SLOT_KEY.SLOT_V_SECTION,
            SLOT_KEY.SLOT_V_FORM_SECTION,
            SLOT_KEY.SLOT_V_STATIC_TABLE_COLUMN
        ],
        image: PreviewDetailImg,
        parentKeys: {
            [SLOT_KEY.SLOT_SECTION]: [
                { key: 'page-title-main', label: 'Section Page Title' },
                { key: 'wrapper-section-prices', label: 'Tab Prices - Wrapper Section' },
                { key: 'wrapper-section-assets', label: 'Tab Assets - Wrapper Section' },
                { key: 'wrapper-section-related-jobs', label: 'Tab History Related Jobs - Wrapper Section' },
                { key: 'wrapper-section-outbound-email', label: 'Tab History Outbound Emails - Wrapper Section' },
                { key: 'wrapper-section-map', label: 'Tab Info Address Map - Wrapper Section' },
            ],
            [SLOT_KEY.SLOT_V_SECTION]: [
                { key: 'wrapper-detail-form', label: 'Tab Details - Wrapper Section' },
                { key: 'wrapper-section-audit', label: 'Tab History Audit - Wrapper section' },
                { key: 'quote-price-material', label: 'Quote Price - Material Line' },

            ],
            [SLOT_KEY.SLOT_V_FORM_SECTION]: [
                { key: 'contacts-tab', label: 'Tab Contacts - Wrapper Section' },
                { key: 'notes-tab', label: 'Tab Info Notes - Wrapper form' },
            ],
            [SLOT_KEY.SLOT_V_STATIC_TABLE_COLUMN]: [
                { key: 'table-issue-stock-header', label: 'Upgrade Quote - Table "Issue From Stock" header' },
                { key: 'table-issue-stock-body', label: 'Upgrade Quote - Table "Issue From Stock" body' },
                { key: 'table-create-po-header', label: 'Upgrade Quote - Table "Create PO" header' },
                { key: 'table-create-po-body', label: 'Upgrade Quote - Table "Create PO" body' },
                { key: 'table-issue-stock-editable-body', label: 'Upgrade Quote - Table "Issue From Stock" editable body' }
            ],
        },
        options: {
            [SLOT_KEY.SLOT_SCRIPTS]: [
                {
                    key: 'MARKETPLACE_EVENT_ON_MOUNTED',
                    label: 'Triggered On Mounted',
                },
                {
                    key: 'MARKETPLACE_EVENT_TRIGGERED_COST_LINE_RENDER',
                    label: 'Triggered Cost Line Render',
                },
                { 
                    key: 'MARKETPLACE_EVENT_AFTER_SAVE_COST_LINE_SUCCESS', 
                    label: 'After save cost line success' 
                },
                { 
                    key: 'MARKETPLACE_EVENT_AFTER_DELETE_COST_LINE_SUCCESS', 
                    label: 'After delete cost line success' 
                },
                {
                    key: 'MARKETPLACE_EVENT_AFTER_CLONE_QUOTE_SECTION_SUCCESS',
                    label: 'After clone quote section success',
                },
                {
                    key: 'MARKETPLACE_EVENT_GET_MATERIAL_DATA_SUCCESS',
                    label: 'Get material data success'
                },
                {
                    key: 'MARKETPLACE_EVENT_VALIDATE_ISSUE_QTY',
                    label: 'Upgrade Quote - Validate issue quantity',
                },
                {
                    key: 'MARKETPLACE_EVENT_FETCH_MATERIAL_LIST_SUCCESS',
                    label: 'Upgrade Quote - Fetch material list success',
                },

            ],
        },
        replaceElements: {
             [SLOT_KEY.SLOT_V_SECTION]: [
                { key: 'quantity-cost-elements', label: 'Material Cost Quantity Elements' },
            ],
        },
    },
]
export default routes;